

<div style="display: flex; flex-direction: column;row-gap: 4px;">
    <slot />
</div>